import { comparerByDate } from '@app/comparers';
import { FollowShipment } from '@app/models/follow-shipment';
import {
  FollowShipmentActionsUnion,
  FollowShipmentActionTypes
} from '@app/modules/core/actions/follow-shipment.actions';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface State extends EntityState<FollowShipment> {
  loading: boolean;
  loaded: boolean;
  creating: boolean;
}

export const adapter: EntityAdapter<FollowShipment> = createEntityAdapter<
  FollowShipment
>({
  selectId: (shipment: FollowShipment) => shipment.id,
  sortComparer: comparerByDate('ASC', 'departureDate')
});

export const INITIAL_STATE: State = adapter.getInitialState({
  loading: false,
  loaded: false,
  creating: false
});

export function reducer(
  state: State = INITIAL_STATE,
  action: FollowShipmentActionsUnion
) {
  switch (action.type) {
    case FollowShipmentActionTypes.Load:
      return { ...state, loading: true };

    case FollowShipmentActionTypes.LoadFail:
      return { ...state, loading: false };

    case FollowShipmentActionTypes.LoadSuccess:
      return {
        ...state,
        loading: false,
        loaded: true
      };
    case FollowShipmentActionTypes.Create:
      return { ...state, creating: true };

    case FollowShipmentActionTypes.CreateFail:
    case FollowShipmentActionTypes.CreateSuccess:
      return { ...state, creating: false };

    case FollowShipmentActionTypes.AddAll:
      return adapter.addAll(action.shipments, state);

    case FollowShipmentActionTypes.AddOne:
      return adapter.addOne(action.shipment, state);

    case FollowShipmentActionTypes.AddMany:
      return adapter.addMany(action.shipments, state);

    case FollowShipmentActionTypes.RemoveOne:
      // console.log(action.shipment);
      return adapter.removeOne(action.shipment, state);

    case FollowShipmentActionTypes.UpdateOne:
      return adapter.updateOne({id: action.shipment.id, changes: action.shipment}, state);

    default:
      return state;
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal
} = adapter.getSelectors();

export const selectLoaded = (state: State) => state.loaded;
export const selectLoading = (state: State) => state.loading;
export const selectCreating = (state: State) => state.creating;

export const getState = createFeatureSelector<State>('followShipments');
export const getAll = createSelector(
  getState,
  selectAll
);
